goog.provide('el8.util.amplitude.patientChartHelpers');

goog.require('el8.util.amplitude.helpers');
goog.require('el8.util.consts');


/**
 * Log start new patient chart event occurred.
 *
 * @param {string} source - location of the source mindreader.
 */
el8.util.amplitude.logStartPatientChart = function(source) {
    var ampData = {
        'source': el8.util.consts.TAXONOMY_PATIENT_CHART_CREATION_SOURCE_MAP[source] || source
    };
    el8.util.amplitude.logEvent('start new patient chart', ampData);
};

/**
 * Log when the CheckPMP Request is initiated.
 *
 * @param {string} source - identification of where the source was launched from
 * @param {string} message - identification of what message was shown to user
 */
el8.util.amplitude.logStartCheckPMPRequest = function(source) {
    var ampData = {
        'source': el8.util.consts.CHECK_PMP_HEADER_ID_NAME_MAP[source] || source,
        'pt_state': el8.ptdata.patients.allAsSoyMaps()[0].state,
    };
    el8.util.amplitude.logEvent('start Check PMP request', ampData);
};

/**
 * Log that CheckPMP response is received.
 * @param {string} message - identification of what message was shown to user
 */
el8.util.amplitude.logCheckPMPResponseReceived = function(message) {
    var ampData = {
        'error': message
    };
    el8.util.amplitude.logEvent('PMP Check Response Received', ampData);
};

/**
 * Log that CheckPMP document was sent as an office message.
 */
el8.util.amplitude.logPMPCheckSentMessage = function() {
    el8.util.amplitude.logEvent('Sent PMP check as message');
};

/**
 * Log that CheckPMP event was exported to a note.
 */
el8.util.amplitude.logPMPExportedNote = function() {
    el8.util.amplitude.logEvent('Exported PMP check to note');
};

/**
 * Log that CheckPMP document was removed from the Chronological Record.
 */
el8.util.amplitude.logPMPRemovedFromRecord = function() {
    el8.util.amplitude.logEvent('PMP check removed');
};

/**
 * Log that user opens the visit note co-signing dialog from the chart feed.
 */
el8.util.amplitude.logCoSignVisitNoteStart = function(visitNoteId) {
    el8.util.amplitude.logEvent('start co-sign', {
        'Document Id': visitNoteId
    });
}
